import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"
import Info2Feature from "@common/features/Info2"

const Info2 = () => {
  const contentControls = useStore((s) => s.contentControls)
  const syncState = useStore((s) => s.syncState)

  useEffect(() => {
    syncState({
      categoriesVisible: true,
      contentControls: {
        index: 0,
      },
    })
  }, [])

  return (
    <Wrapper>
      <Info2Feature />
    </Wrapper>
  )
}

export default Info2

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: var(--primary);
`
